export default __webpack_public_path__ + "static/media/bell.be043143.svg";